(function () {
  'use strict';

  var w = window;
  var d = document;
  var script = d.currentScript;
  if (!script) return;
  function status(value) {
    // Operational state only; never expose consent records or visitor data.
    try { script.setAttribute('data-status', value); } catch (_statusError) { /* Diagnostics are optional. */ }
  }
  var id = script.getAttribute('data-measurement-id') || '';
  if (!/^G-[A-Z0-9]{6,20}$/.test(id)) { status('environment-blocked'); return; }
  if (w.deramicAnalyticsFlush) return;
  status('environment-blocked');

  var disableKey = 'ga-disable-' + id;
  w[disableKey] = true;
  var page;
  try {
    page = new URL(w.location.href);
    if (page.protocol !== 'https:' || page.hostname !== 'deramicdesign.com' || page.port) return;
    if (script.getAttribute('data-theme-role') !== 'main') return;
    if (!w.Shopify || !w.Shopify.theme || w.Shopify.theme.role !== 'main' || w.Shopify.designMode || w.Shopify.inspectMode || w.Shopify.visualPreviewMode) return;
    var preview = false;
    page.searchParams.forEach(function (_value, key) {
      if (/^(preview(?:_|$)|shopify-editor$|_fd$|_ab$|_sc$|pb$)/i.test(key)) preview = true;
    });
    if (preview) return;
  } catch (_environmentError) { return; }

  // One client per document. Never replace or intercept the legacy data layer.
  if (w.dataLayer && !Array.isArray(w.dataLayer)) return;
  w.dataLayer = w.dataLayer || [];
  w.deramicAnalyticsQueue = w.deramicAnalyticsQueue || [];

  var allowed = false;
  var permissionStatus = 'privacy-pending';
  var loaderState = 'idle';
  var configured = false;
  var pageSent = false;
  var leadPending = false;
  var leadSent = false;
  var leadName = 'deramic_project_enquiry_success';

  // Drop arbitrary query values, click IDs and fragments. Only a fixed platform/
  // medium vocabulary survives; campaign names, terms and content never do.
  var safePage = new URL(page.origin + page.pathname);
  if (/@|%40/i.test(safePage.pathname)) safePage.pathname = '/';
  var attribution = {
    utm_source: ['instagram', 'facebook', 'google', 'bing', 'pinterest', 'linkedin', 'youtube', 'tiktok', 'chatgpt', 'chatgpt.com', 'perplexity', 'claude', 'gemini', 'newsletter'],
    utm_medium: ['social', 'paid_social', 'cpc', 'ppc', 'email', 'referral', 'organic', 'display', 'affiliate', 'video']
  };
  Object.keys(attribution).forEach(function (key) {
    var values = page.searchParams.getAll(key);
    if (values.length === 1 && attribution[key].indexOf(values[0]) !== -1) safePage.searchParams.set(key, values[0]);
  });
  var safeReferrer = '';
  try {
    var referrer = new URL(d.referrer);
    if (referrer.protocol === 'https:' || referrer.protocol === 'http:') safeReferrer = referrer.origin + '/';
  } catch (_referrerError) { /* Empty or invalid referrers are omitted. */ }

  function command() {
    w.dataLayer.push(arguments);
  }

  function eventParameters() {
    return {
      send_to: id,
      page_location: safePage.href,
      page_referrer: safeReferrer,
      // Search result titles can contain visitor-entered text; report by path.
      page_title: 'deramic'
    };
  }

  function drainQueue() {
    var queue = w.deramicAnalyticsQueue;
    if (!Array.isArray(queue)) return;
    for (var index = 0; index < queue.length; index++) {
      if (queue[index] === leadName && !leadSent) leadPending = true;
    }
    queue.length = 0;
  }

  function readPermission() {
    permissionStatus = 'privacy-pending';
    try {
      var privacy = w.Shopify && w.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return false;
      var permitted = privacy.analyticsProcessingAllowed() === true;
      permissionStatus = permitted ? 'loading' : 'permission-denied';
      return permitted;
    } catch (_permissionError) { permissionStatus = 'failed'; return false; }
  }

  function sendReadyEvents() {
    if (!allowed || loaderState !== 'loaded') return;
    if (!configured) {
      command('js', new Date());
      command('config', id, {
        send_page_view: false,
        allow_google_signals: false,
        allow_ad_personalization_signals: false,
        page_location: safePage.href,
        page_referrer: safeReferrer,
        page_title: 'deramic'
      });
      configured = true;
    }
    if (!pageSent) {
      command('event', 'page_view', eventParameters());
      pageSent = true;
    }
    if (leadPending && !leadSent) {
      command('event', leadName, eventParameters());
      leadSent = true;
      leadPending = false;
    }
  }

  function failClosed() {
    allowed = false;
    w[disableKey] = true;
    status('failed');
  }

  function refresh() {
    try {
      drainQueue();
      if (loaderState === 'failed') { failClosed(); return; }
      allowed = readPermission();
      w[disableKey] = !allowed;
      if (!allowed) { status(permissionStatus); return; }
      status('loading');
      if (loaderState === 'idle') {
        loaderState = 'loading';
        var tag = d.createElement('script');
        tag.async = true;
        tag.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(id);
        tag.onload = function () {
          loaderState = 'loaded';
          refresh();
        };
        tag.onerror = function () {
          loaderState = 'failed';
          failClosed();
        };
        d.head.appendChild(tag);
      }
      sendReadyEvents();
      if (loaderState === 'loaded' && configured) status('active');
    } catch (_measurementError) {
      loaderState = 'failed';
      failClosed();
    }
  }

  // Contact adds only the event name after Shopify confirms success. A success
  // that precedes this deferred asset or permission resolution stays in memory
  // for this page only. Reloads cannot replay this client's pending event.
  w.deramicAnalyticsFlush = refresh;
  d.addEventListener('visitorConsentCollected', refresh);
  refresh();
  if ((!w.Shopify.customerPrivacy || typeof w.Shopify.customerPrivacy.analyticsProcessingAllowed !== 'function') && typeof w.Shopify.loadFeatures === 'function') {
    try {
      w.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (error) { failClosed(); return; }
        refresh();
      });
    } catch (_privacyLoadError) { failClosed(); }
  }
})();
